import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import { bolsas_media_unidade, bolsas_media_unidade_contribuinte } from "../../services/api";

import './detalhamento_bolsa.css';

const Bolsa_media_unidade = (props) => {



    const [data2, setData2] = useState([]);
    const [dataC, setDataC] = useState([]);

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes']

    let data_inicio = props.di;
    let data_fim = props.df;
    let cod_unidade = props.un;

    const fetchData = async () => {
        try {
            const response = await bolsas_media_unidade(data_inicio, data_fim);
            setData2(response);
            const responseC = await bolsas_media_unidade_contribuinte(data_inicio, data_fim);
            setDataC(responseC);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {

        fetchData();
    }, [data_inicio, data_fim]);

    let chartBolMedUni = [];

    if (typeof data2 !== 'undefined') {

        const dadosFiltrados = data2.filter(item => item.sec === cod_unidade);
        chartBolMedUni = dadosFiltrados.map((item, index) => {

            if (item.sec === cod_unidade) {
                const row = ["Média"];
                row.push(parseFloat(item.round));
                return row;
            }
        });
        if (chartBolMedUni.length === 0) {
            chartBolMedUni.push(["Média", 0]);
        }

        chartBolMedUni.unshift(["Label", "Value"]);
    };

    let chartBolMedUniC = [];

    if (typeof dataC !== 'undefined') {

        const dadosFiltradosC = dataC.filter(item => item.sec === cod_unidade);
        chartBolMedUniC = dadosFiltradosC.map((item, index) => {

            if (item.sec === cod_unidade) {
                const row = ["Média C."];
                row.push(parseFloat(item.round));
                return row;
            }
        });
        if (chartBolMedUniC.length === 0) {
            chartBolMedUniC.push(["Média C.", 0]);
        }

        chartBolMedUniC.unshift(["Label", "Value"]);
    };



    const options = {
        width: 120, height: 120,
        redFrom: 33, redTo: 66,
        yellowFrom: 24, yellowTo: 33,
        minorTicks: 5,
        max: 66,
        min: 0
    };


    return (
        <div className="bolsasMU">
            <center>

                Bolsa Média da Unidade
                <Chart
                    chartType="Gauge"
                    version="current"
                    width="120px"
                    height="120px"
                    data={chartBolMedUni}
                    options={options}
                />
                Bolsa Média dos Contribuintes
                <Chart
                    chartType="Gauge"
                    version="current"
                    width="120px"
                    height="120px"
                    data={chartBolMedUniC}
                    options={options}
                />
            </center>
        </div>
    );
};
export default Bolsa_media_unidade;
